import { useEffect, useState } from "react"
import { HStack, Separator, Spinner, Stack } from "@chakra-ui/react"
import { OfferComponent } from "./components"
import { Button, Section, Text } from "@/components"
import { Deal, DealOffer } from "@/types"
import { ALL_STEPS } from "@/constants"

interface Props {
  isLoading: boolean
  deals: Deal[]
}

export const DealsComponent = ({ deals, isLoading }: Props) => {
  const [currentDeal, setCurrentDeal] = useState<Deal | null>(null)
  const [currentOffer, setCurrentOffer] = useState<DealOffer | null>(null)
  const [currentStepIndex, setCurrentStepIndex] = useState<number>(0)

  useEffect(() => {
    if (deals && deals.length > 0) {
      setCurrentDeal(deals[0])
      console.log("Client Deals:", deals)
    }
  }, [deals])

  useEffect(() => {
    if (currentDeal) {
      const index = ALL_STEPS.findIndex(step => step.step === currentDeal.portalStage);
      setCurrentStepIndex(index !== -1 ? index : 0);

      if (currentDeal.offers && currentDeal.offers.length > 0) {
        setCurrentOffer(currentDeal.offers[0])
      } else {
        setCurrentOffer(null)
      }
    }
  }, [currentDeal])

  return (
    <Section>
      <Text fontSize="2xl" fontWeight="bold" fontFamily="body">
        Your Deals
      </Text>
      {
        isLoading ? (
          <HStack w="100%" justifyContent="center" alignItems="center" p={10}>
            <Spinner />
          </HStack>
        ) : (
          <>
            <HStack mt={5} gap={2}>
              {
                deals && deals.map((deal, index) => (
                  <Button
                    key={index}
                    variant={ deal.id === currentDeal?.id ? "solid" : "outline"}
                    onClick={() => setCurrentDeal(deal)}
                  >
                    {deal.company.name}
                  </Button>
                ))
              }
            </HStack>
            <HStack mt={10}>
              {
                deals && currentDeal && currentDeal.offers && currentDeal.offers.length > 0 ? (
                  currentDeal.offers.map((offer, index) => (
                    <Button
                      key={index}
                      variant={ offer.id === currentOffer?.id ? "tabSelected" : "tabUnselected"}
                      onClick={() => setCurrentOffer(offer)}
                    >
                      {`Offer: ${index + 1}`}
                    </Button>
                  ))
                ) : (
                  <Text>No offers available</Text>
                )
              }
            </HStack>
            <Separator mt={0} />
            <Stack>
              {
                currentOffer && currentDeal && (
                  <OfferComponent
                    dealId={currentDeal.id}
                    offer={currentOffer}
                    currentStepIndex={currentStepIndex}
                  />
                )
              }
            </Stack>
          </>
        )
      }
    </Section>
  )
}
